import React from 'react';
import {
  AppBar,
  AppBarProps,
  Box,
  Link,
  Toolbar,
  alpha,
  styled,
} from '@mui/material';
import { Link as LinkRouter } from 'react-router-dom';
import { getPolyglot } from '../../../../i18n';
import logoFooterSrc from './logo-footer.svg';

const LinkStyled: typeof Link = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  textDecoration: 'underline',
  '&:hover': {
    color: alpha(theme.palette.primary.contrastText, 0.8),
  },
})) as typeof Link;
export interface LinksFooterProps extends AppBarProps {
  logoFooter?: string;
  urlAboutUs?: string;
  slots?: { LinkComponent: typeof Link };
  logoHeight?: string | number;
  urlStatus?: string;
  predefinedLinks?: Record<
    string,
    {
      label: string;
      to: string;
      external: boolean;
    }
  >;
}
function LinksFooter(props: LinksFooterProps) {
  const {
    logoFooter = logoFooterSrc,
    urlAboutUs = 'http://stoerk-tronic.com/',
    urlStatus = 'https://stats.uptimerobot.com/xxuCT7SMXT',
    predefinedLinks = {},
    ...appBarProps
  } = props;
  const LinkComponent = props.slots?.LinkComponent ?? LinkStyled;
  const polyglot = getPolyglot();
  const links = {
    [polyglot.t('footer.terms_and_conditions')]: {
      label: polyglot.t('footer.terms_and_conditions'),
      to: '/terms-and-conditions',
      external: false,
    },
    [polyglot.t('footer.privacy_policy')]: {
      label: polyglot.t('footer.privacy_policy'),
      to: '/privacy',
      external: false,
    },
    [polyglot.t('footer.cookie_policy')]: {
      label: polyglot.t('footer.cookie_policy'),
      to: '/cookies',
      external: false,
    },
    [polyglot.t('footer.impressum')]: {
      label: polyglot.t('footer.impressum'),
      to: '/impressum',
      external: false,
    },
    [polyglot.t('footer.about_us')]: {
      label: polyglot.t('footer.about_us'),
      to: urlAboutUs,
      external: true,
    },
    [polyglot.t('footer.status')]: {
      label: polyglot.t('footer.status'),
      to: urlStatus,
      external: true,
    },
    ...predefinedLinks,
  };

  return (
    <AppBar
      position="static"
      component={'footer'}
      color="primary"
      sx={{
        alignItems: 'center',
        display: { xs: 'none', md: 'flex' },
      }}
      {...appBarProps}
    >
      <Toolbar
        sx={{
          height: '4rem',
          maxWidth: 1536,
          justifyContent: 'space-between',
          mx: 2,
          gap: 2,
          width: '100%',
          margin: 'auto',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <Box
          sx={{
            gap: { lg: '4rem', md: '2rem' },
            display: 'flex',
          }}
        >
          {Object.values(links).map((link) =>
            link.external ? (
              <LinkComponent key={link.to} href={link.to} target="_blank">
                {link.label}
              </LinkComponent>
            ) : (
              <LinkComponent key={link.to} to={link.to} component={LinkRouter}>
                {link.label}
              </LinkComponent>
            )
          )}
        </Box>

        {!!logoFooter && (
          <img
            src={logoFooter}
            height={props.logoHeight ?? 30}
            alt="logo-stoerk"
          />
        )}
      </Toolbar>
    </AppBar>
  );
}

export default LinksFooter;
